module.exports = __webpack_public_path__ + "static/media/homeImage1.20f69417.png";